// this helper is poorly conceived (used for both react-query and axios error message building)
// TODO: full refactor and better global design for error message building

import { AxiosError } from 'axios'
import { IApiClaravineErrorData } from 'api'

/**
 * Handle error messages from react-query.
 * @returns {string | null} Error message
 */

export function makeQueryErrorMessage(error: Error): string | null {
  let { message, errors, code }: IApiClaravineErrorData = {}

  if (!(error instanceof AxiosError)) {
    // TODO: track this
    return null
  }

  const typedError = error as AxiosError<IApiClaravineErrorData | undefined>
  message = typedError.response?.data?.message ?? typedError.message
  errors = typedError.response?.data?.errors ?? []
  code = typedError.code

  let errorMessage = ''

  if (message) {
    errorMessage += message
  }

  if (errors.length > 0) {
    errorMessage += errorMessage ? ` : ${errors.join(', ')}` : errors.join(', ')
  } else if (code) {
    errorMessage += errorMessage ? ` : ${code}` : code
  }

  return errorMessage
}
